<template>
  <Breadcrumbs
      title="Items"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Items', path: '/items' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <itemListTable/>
    </div>
  </div>
</template>

<script>
import itemListTable from "@/pages/master_data/items/items/itemListTable.vue";

export default {
  name: 'itemList',
  components: {
    itemListTable,
  },
}
</script>
